module.exports = function getResource(label, vars = []) {
    let resources = {
        yourBirthday: 'Your birthday',
        callSephora: 'If you need to change your birth date, please call Sephora at '
    };
    return resources[label];
};
